import { render, staticRenderFns } from "./PRentalStatus.vue?vue&type=template&id=ddeba62c"
import script from "./PRentalStatus.vue?vue&type=script&lang=js"
export * from "./PRentalStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports